import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Print from "vue-print-nb";

import "bootstrap/dist/css/bootstrap.min.css";

Vue.config.productionTip = false;
Vue.use(Print);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
